import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';

import { PermissionsEnum } from 'consts/permissions';
import Auth from 'modules/Auth';
import styles from './ImageRenderer.pcss';
import { ImageRendererProps, TARGET } from './ImageRenderer.types';

const cx = classNames.bind(styles);

const ImageRenderer = ({
  data,
  target = TARGET.SELF,
  hoverIcon = null,
  link = '',
  isExternalLink = false,
}: ImageRendererProps): React.ReactElement | null => {
  if (!data) return null;

  const thumbnail = (
    <div
      className={cx('image-wrap', 'bg-center bg-cover bg-no-repeat')}
      style={{ backgroundImage: `url(${data.thumbnail})` }}
    >
      {Auth.hasPermission(PermissionsEnum.CONTENT_REVIEW) ? (
        <div className="h-full text-neutral-100 flex justify-center items-center opacity-0 hover:opacity-100">
          {hoverIcon}
        </div>
      ) : null}
    </div>
  );

  if (!Auth.hasPermission(PermissionsEnum.CONTENT_REVIEW)) return thumbnail;

  if (isExternalLink) {
    return (
      <a href={link} target={target} rel="noopener noreferrer" data-test-id="thumbnail-external-link">
        {thumbnail}
      </a>
    );
  }

  return (
    <Link to={link} target={target} data-test-id="thumbnail-link">
      {thumbnail}
    </Link>
  );
};

export default ImageRenderer;
